export const PROTOCOL_VERSION = 3;
export const MATCH_FORFEIT_CLOSE_CODE = 4000;
export const QUEUE_TICKET_TTL_MS = 10 * 60 * 1_000;
